import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  hrmsCompanySearch: {
    cursor: "pointer",
    margin: "5px 0px",
  },
}));
const CompanySearch = ({ highlightText, item }) => {
  const classes = useStyle();
  const navigate = useNavigate();
  const handleRedirect = ({ props }) => {
    navigate("/company");
  };
  return (
    <Grid className={classes.hrmsCompanySearch} onClick={handleRedirect}>
      <Typography>{highlightText(item.company_name)}</Typography>
    </Grid>
  );
};

export default CompanySearch;
